export const SAMPLE_SINGLE_SUCCESS = 'sample-form/sample-single-success';
export const SAMPLE_UPDATE_SUCCESS = 'sample-form/sample-update-success';
export const SAMPLE_CLEAR = 'sample-form/sample-clear';
export const SAMPLE_AUDIT = 'sample-form/sample-audit';
export const GET_SAMPLE_FORM = 'sample-form/get-sample-form';
export const GET_SAMPLE_ERROR = 'sample-form/get-sample-error';
export const SAMPLE_CREATE_SUCCESS = 'sample-form/sample-create-success';